var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"message",class:{
    'message-error': _vm.type === 'error',
    'message-success': _vm.type === 'success',
    'message-warning': _vm.type === 'warning',
    fix: _vm.fix
  },style:(_vm.positionStyle)},[_vm._v("\n  "+_vm._s(_vm.info)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }